import axios from 'axios';
import { useMutation, useQueryClient } from 'react-query';
import { API_URL, getCachedSessionId } from '../../../services/common';
import { useNotification } from '../../../providers/notificationsProvider';

const createProject = async (project) => {
  const response = await axios.post(`${API_URL}/v1/project`, project, {
    headers: { 'x-session-id': getCachedSessionId() }
  });

  return response.data;
};

export const useCreateProject = () => {
  const queryClient = useQueryClient();
  const { notify } = useNotification();
  return useMutation(createProject, {
    onError: (error) => {
      notify({ message: error.message, severity: 'error' });
    },
    onSuccess: () => {
      notify({ message: 'Project was created successfully', severity: 'success' });
      queryClient.invalidateQueries(['projects']);
    }
  });
};
